import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

// middlewares
import auth from '../middleware/auth';

import ProjectList from '../views/project/ProjectList.vue'
import ProjectDetails from '../views/project/ProjectDetails.vue'
import Dashboard from '../views/Dashboard.vue'

/* non auth routes */
import Login from '../views/auth/Login.vue'
import Register from '../views/auth/Register.vue'

/* Store */
import store from '@/store'

/* 404 */
import Page404 from '../views/Page404'

// Test route
import Test from '../views/Test'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'ProjectList',
    component: ProjectList,
    //meta: {
      //middleware: auth,
    //},
    beforeEnter: (to, from, next) => {
      console.log('tihs user', store.getters.getUser)
      console.log('localStorage', localStorage.logged)
      if (localStorage.logged == 'false') {
        next('/login');
        return;
      }
      next();
    }
  },
  {
    path: '/project-details',
    name: 'ProjectDetails',
    component: ProjectDetails,
  },
  {
    path: '/:id/dashboard',
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: "*", 
    component: Page404 
  },
  {
    path: '/test',
    name: 'Test',
    component: Test
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
